module.exports = __webpack_public_path__ + "img/app-indicator.f8c461ca.svg";